// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sponsorCroForm_sponsorCroFormContainer__vLd1Z {
  background-color: transparent;
  color: #fff;
  padding: 2em;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Form Layout */
.sponsorCroForm_formSection__sRKBn {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 700px;
}

/* Input and Textarea Styling */
.sponsorCroForm_formControl__f2yp- {
  width: 100%;
  padding: 1em;
  font-size: 1em;
  border-radius: 1.5em;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: transparent;
  color: #fff;
  transition: border-color 0.3s ease;
}

.sponsorCroForm_formControl__f2yp-:focus {
  outline: none;
  border-color: #aab5b7;
}

.sponsorCroForm_formControl__f2yp-::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* Labels */
.sponsorCroForm_label__PiVjX {
  font-size: 1em;
  margin-bottom: 0.5em;
  color: #fff;
}

/* Required Asterisk */
.sponsorCroForm_required__vB37j {
  font-weight: 600;
  color: #e74c3c;
  margin-left: 4px;
}

/* Submit Button */
.sponsorCroForm_submitButton__m1bpt {
  padding: 0.5em 4em;
  font-size: 1.1em;
  color: #444;
  background-color: #fff !important;
  border-color: rgb(79, 81, 79) !important;
  border-radius: 2em;
  width: 100%;
  transition: background-color 0.3s ease;
}

.sponsorCroForm_submitButton__m1bpt:hover {
  background-color: #e1e1e1 !important;
}

/* Toast Styling */
.sponsorCroForm_toast-body__OXgep {
  font-size: 1em;
  font-weight: 500;
  color: #fff;
}
/* Overlay Spinner Styling */
.sponsorCroForm_overlay__sgReA {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(17, 17, 17, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 1em;
}

/* Responsive Design */
@media (max-width: 992px) {
  .sponsorCroForm_formControl__f2yp- {
    width: 100%;
  }

  .sponsorCroForm_submitButton__m1bpt {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .sponsorCroForm_sponsorCroFormContainer__vLd1Z {
    padding: 1.5em;
  }

  .sponsorCroForm_formSection__sRKBn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/FORM/SPONSOR_CONTACT/sponsorCroForm.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,6BAA6B;EAC7B,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".sponsorCroFormContainer {\n  background-color: transparent;\n  color: #fff;\n  padding: 2em;\n  border-radius: 15px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Form Layout */\n.formSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 700px;\n}\n\n/* Input and Textarea Styling */\n.formControl {\n  width: 100%;\n  padding: 1em;\n  font-size: 1em;\n  border-radius: 1.5em;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  background-color: transparent;\n  color: #fff;\n  transition: border-color 0.3s ease;\n}\n\n.formControl:focus {\n  outline: none;\n  border-color: #aab5b7;\n}\n\n.formControl::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Labels */\n.label {\n  font-size: 1em;\n  margin-bottom: 0.5em;\n  color: #fff;\n}\n\n/* Required Asterisk */\n.required {\n  font-weight: 600;\n  color: #e74c3c;\n  margin-left: 4px;\n}\n\n/* Submit Button */\n.submitButton {\n  padding: 0.5em 4em;\n  font-size: 1.1em;\n  color: #444;\n  background-color: #fff !important;\n  border-color: rgb(79, 81, 79) !important;\n  border-radius: 2em;\n  width: 100%;\n  transition: background-color 0.3s ease;\n}\n\n.submitButton:hover {\n  background-color: #e1e1e1 !important;\n}\n\n/* Toast Styling */\n.toast-body {\n  font-size: 1em;\n  font-weight: 500;\n  color: #fff;\n}\n/* Overlay Spinner Styling */\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(17, 17, 17, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-radius: 1em;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .formControl {\n    width: 100%;\n  }\n\n  .submitButton {\n    width: 100%;\n  }\n}\n\n@media (max-width: 576px) {\n  .sponsorCroFormContainer {\n    padding: 1.5em;\n  }\n\n  .formSection {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sponsorCroFormContainer": `sponsorCroForm_sponsorCroFormContainer__vLd1Z`,
	"formSection": `sponsorCroForm_formSection__sRKBn`,
	"formControl": `sponsorCroForm_formControl__f2yp-`,
	"label": `sponsorCroForm_label__PiVjX`,
	"required": `sponsorCroForm_required__vB37j`,
	"submitButton": `sponsorCroForm_submitButton__m1bpt`,
	"toast-body": `sponsorCroForm_toast-body__OXgep`,
	"overlay": `sponsorCroForm_overlay__sgReA`
};
export default ___CSS_LOADER_EXPORT___;
